module.exports = __webpack_public_path__ + "static/media/SearchIcon.f6315a33.svg";